import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { EmployeeManager } from '../entities/employee-manager';

@Injectable()
export class EmployeeManagerService extends BaseCrudService<EmployeeManager> {

  public uri = '/api/employeeManager/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance EmployeeManagerService');
  }

  buildSentence(entity?: EmployeeManager, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = '';
      query = query.concat(
        entity.isCurrent ?
          `isCurrent${QueryOperator.Equal}${entity.isCurrent}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.status ?
          `status${QueryOperator.Equal}${entity.status}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      if (entity.level && entity.level.id) {
        query = query.concat(
          `level.id${QueryOperator.Equal}${entity.level.id}${QueryOperator.Split}`
        );
      }      
      if (entity.employee) {
        query = query.concat(entity.employee.id ?
          `employee.id${QueryOperator.Equal}${entity.employee.id}${QueryOperator.Split}`
          : QueryOperator.Empty
        );
        query = query.concat(entity.employee && entity.employee.executingUnit ?
          `employee.executingUnit.id${QueryOperator.Equal}${entity.employee.executingUnit.id}${QueryOperator.Split}`
          : QueryOperator.Empty
        );
        query = query.concat(entity.employee.name ?
          `employee.name${QueryOperator.Contain}${entity.employee.name}${QueryOperator.Split}`
          : QueryOperator.Empty
        );
        query = query.concat(entity.employee.firstLastName ?
          `employee.firstLastName${QueryOperator.Contain}${entity.employee.firstLastName}${QueryOperator.Split}`
          : QueryOperator.Empty
        );
        query = query.concat(entity.employee.secondLastName ?
          `employee.secondLastName${QueryOperator.Contain}${entity.employee.secondLastName}${QueryOperator.Split}`
          : QueryOperator.Empty
        );
      }
      query = query.concat(entity.costCenter && entity.costCenter.id ?
        `costCenter.id${QueryOperator.Equal}${entity.costCenter.id}${QueryOperator.Split}`
        : QueryOperator.Empty
      );
      query = query.concat(entity.costCenter && entity.costCenter.fiscalYear ?
        `costCenter.fiscalYear.id${QueryOperator.Equal}${entity.costCenter.fiscalYear.id}${QueryOperator.Split}`
        : QueryOperator.Empty
      );
      query = query.concat(entity.costCenter && entity.costCenter.executingUnit ?
        `costCenter.executingUnit.id${QueryOperator.Equal}${entity.costCenter.executingUnit.id}${QueryOperator.Split}`
        : QueryOperator.Empty
      );

      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/employee-manager.service.ts